export default "__VITE_ASSET__BBcENORY__"